document.addEventListener('DOMContentLoaded', () => {
  const main = new Main();
});

class Main {
  constructor() {
    this._observers = [];
    this._init();
  }

  set observers(val) {
    this._observers.push(val);
  }

  get observers() {
    return this._observers;
  }

  _init() {
    this._scrollInit();
    this._howDetailInit();
  }

  // appearのアニメーション。一度表示されたら表示状態を維持する。
  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add('inview');
    }
  }


  _destroyObservers() {
    this.observers.forEach(ob => {
      ob.destroy();
    });
  }

  destroy() {
    this._destroyObservers();
  }

  _scrollInit() {
    if (typeof ScrollObserver === 'undefined' || !document.querySelector('.appear')) return;

    // appearのアニメーション(appearの子要素)
    this.observers = new ScrollObserver(
      '.appear',
      this._inviewAnimation.bind(this),
      { rootMargin: '0px 0px -20% 0px' }
    );
  }

  _howDetailInit() {
    const wrappers = document.querySelectorAll('[data-how-detail], .c-how-detail');

    wrappers.forEach(wrapper => {
      this._setupHowDetail(wrapper);
    });
  }

  _setupHowDetail(wrapper) {
    const tabs = wrapper.querySelector('.c-how-detail__tabs');
    if (!tabs) return;

    const tabsScope = wrapper.querySelector('[data-how-tabs-scope]');
    const tabsAnchor = wrapper.querySelector('[data-how-tabs-anchor]') || wrapper.querySelector('.c-how-detail__tabs-anchor') || tabs;
    const tabButtons = Array.from(tabs.querySelectorAll('[data-how-tab]'));
    const panels = Array.from(wrapper.querySelectorAll('[data-how-panel]'));
    const mediaQuery = window.matchMedia('(max-width: 999px)');
    const activeButton = tabs.querySelector('[data-how-tab].is-active') || tabButtons[0];
    let ticking = false;
    let activeTab = activeButton ? activeButton.dataset.howTab : '';

    if (!activeTab || !panels.length) return;

    const setActiveTab = target => {
      if (!target) return;

      activeTab = target;

      tabButtons.forEach(button => {
        const isActive = button.dataset.howTab === target;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(panel => {
        const isActive = panel.dataset.howPanel === target;

        panel.classList.toggle('is-active', isActive);
        panel.hidden = mediaQuery.matches && !isActive;
      });
    };

    const syncPanels = () => {
      panels.forEach(panel => {
        panel.hidden = mediaQuery.matches && panel.dataset.howPanel !== activeTab;
      });
    };

    const updateStickyState = () => {
      if (!mediaQuery.matches) {
        tabs.classList.remove('is-stuck');
        ticking = false;
        return;
      }

      const stickyTop = parseFloat(getComputedStyle(tabs).top) || 0;
      const tabsRect = tabs.getBoundingClientRect();
      const scopeRect = tabsScope ? tabsScope.getBoundingClientRect() : null;
      const isInsideStickyScope = !scopeRect || scopeRect.bottom > stickyTop + tabsRect.height + 0.5;

      tabs.classList.toggle('is-stuck', tabsRect.top <= stickyTop + 0.5 && isInsideStickyScope);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(updateStickyState);
    };

    const scrollToTabStart = () => {
      const stickyTop = parseFloat(getComputedStyle(tabs).top) || 0;
      const targetTop = window.scrollY + tabsAnchor.getBoundingClientRect().top - stickyTop - 1;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto',
      });
    };

    wrapper.addEventListener('click', event => {
      if (!event.target.closest) return;

      const button = event.target.closest('[data-how-tab]');
      if (!button || !wrapper.contains(button)) return;

      event.preventDefault();

      if (button.classList.contains('c-how-detail__text-underline') && !mediaQuery.matches) return;

      setActiveTab(button.dataset.howTab);

      if (mediaQuery.matches) {
        requestAnimationFrame(scrollToTabStart);
      }
    });

    setActiveTab(activeTab);
    requestUpdate();

    const onMediaChange = () => {
      syncPanels();
      requestUpdate();
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', onMediaChange);
    } else {
      mediaQuery.addListener(onMediaChange);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', onMediaChange);
  }
}
